import { BaseServer } from "namirasoft-core";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { NSHeader } from "./NSHeader";

export abstract class NSBaseServer extends BaseServer
{
    static onBeforeRequest_SetVersion<ReqData>(version: string, config?: AxiosRequestConfig<ReqData>): void
    {
        let header = NSHeader.req.VERSION();
        if (config?.headers)
            config.headers[header] = version;
    }

    static onBeforeRequest_GetVersion<ReqData>(res?: AxiosResponse<ReqData>): string
    {
        let header = NSHeader.req.VERSION();
        if (res?.headers)
            return res.headers[header];
        return "";
    }

    private version: string;

    public backend: {
        version: string
    } = { version: "" };

    constructor(base_url: string, version: string)
    {
        super(base_url);
        this.version = version;

        this.NSOnBeforeRequest = this.NSOnBeforeRequest.bind(this);
        this.NSOnAfterRequest = this.NSOnAfterRequest.bind(this);

        this.addOnBeforeRequest(this.NSOnBeforeRequest);
        this.addOnAfterRequest(this.NSOnAfterRequest);
    }
    private NSOnBeforeRequest<ReqData = any>(_: string, config?: AxiosRequestConfig<ReqData> | undefined): void
    {
        NSBaseServer.onBeforeRequest_SetVersion(this.version, config);
    }
    private NSOnAfterRequest<ResData = any>(_: string, res: AxiosResponse<ResData, any>): void
    {
        this.backend.version = NSBaseServer.onBeforeRequest_GetVersion(res);
    }
};